import { mediaItems } from '@/mocks/home';

const mediaImages: Record<string, string> = {
  'med-1': 'https://readdy.ai/api/search-image?query=Cinematic%20video%20thumbnail%20style%20with%20dramatic%20warm%20lighting%2C%20entertainment%20news%20reporting%20scene%2C%20bold%20contrast%2C%20modern%20editorial%20photography%2C%20dark%20background%20with%20red%20accent%20highlights&width=800&height=500&seq=med-1-51bl&orientation=landscape',
  'med-2': 'https://readdy.ai/api/search-image?query=Live%20streaming%20studio%20dramatic%20scene%20with%20warm%20lighting%2C%20influencer%20content%20creation%20theme%2C%20bold%20orange%20and%20dark%20tones%2C%20modern%20social%20media%20aesthetic%2C%20professional%20video%20production&width=800&height=500&seq=med-2-51bl&orientation=landscape',
  'med-3': 'https://readdy.ai/api/search-image?query=Corporate%20office%20building%20dramatic%20night%20scene%20with%20warm%20interior%20lights%2C%20business%20investigation%20theme%2C%20dark%20atmospheric%20background%2C%20cinematic%20photography%20style%2C%20mysterious%20mood&width=800&height=500&seq=med-3-51bl&orientation=landscape',
  'med-4': 'https://readdy.ai/api/search-image?query=TV%20show%20behind%20scenes%20dramatic%20lighting%20setup%2C%20entertainment%20production%20theme%2C%20warm%20spotlight%20effects%2C%20dark%20studio%20background%2C%20cinematic%20editorial%20style%2C%20professional%20broadcast%20aesthetic&width=800&height=500&seq=med-4-51bl&orientation=landscape',
  'med-5': 'https://readdy.ai/api/search-image?query=Sports%20arena%20dramatic%20atmosphere%20with%20golden%20stadium%20lights%2C%20athletic%20competition%20theme%2C%20dark%20dramatic%20background%2C%20warm%20amber%20illumination%2C%20editorial%20sports%20photography%20style&width=800&height=500&seq=med-5-51bl&orientation=landscape',
};

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950 font-heading mb-3">
            视频爆料
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[600px] mx-auto">
            热门爆料视频精选，现场直击第一手画面
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {mediaItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-2xl overflow-hidden border border-background-200/70 group cursor-pointer hover:scale-[1.01] transition-transform"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={mediaImages[item.id]}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="flex items-center gap-1.5 text-white text-xs bg-black/40 backdrop-blur-sm px-2.5 py-1 rounded-full">
                    <i className="ri-play-fill w-3.5 h-3.5 flex items-center justify-center"></i>
                    {item.duration}
                  </span>
                  <span className="flex items-center gap-1 text-white text-xs bg-black/40 backdrop-blur-sm px-2.5 py-1 rounded-full">
                    <i className="ri-eye-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    {item.views}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-1 rounded-full bg-accent-500 text-white text-xs font-medium">
                    {item.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-bold text-foreground-900 text-sm leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}